import React, { useMemo, memo, forwardRef } from 'react';
import { Link, LinkProps } from '@medlinker/fundamental';
import { appendUrlParams, getCommonParams } from '../../utils/urlHelper';

interface Props extends Omit<LinkProps, 'to'> {
  path?: string;
  to?: string;
  query?: { [key: string]: any };
  /**
   * 是否是e-mall页面，仅跳转e-mall项目使用，会自动加上/ih前缀
   * 这是个历史遗留问题，将来会修复
   */
  reload?: boolean;
  /** 是否是外部链接 */
  outerSite?: boolean;
}

function MedLink(props: Props, fref: any) {
  const { path = '', reload = false, to, outerSite = false, ...rest } = props;

  const finalTo = useMemo(() => {
    if (outerSite) return path || to || '';

    const url = path || to || '';

    if (reload) {
      // 默认跳转ih，会重定向过来，

      return appendUrlParams(`/ih${url}`, getCommonParams());
    }

    return url;
  }, [outerSite, path, to, reload]);

  if (reload || outerSite) {
    return <a ref={fref} {...rest} href={finalTo} />;
  }

  return <Link ref={fref} {...rest} to={finalTo} />;
}

export default memo(forwardRef(MedLink));
